import tttNetworkAbi from './abis/tttNetwork.json'
import tttErc20Abi from './abis/tttErc20.json'

const abis = {
  tttNetwork: tttNetworkAbi,
  tttErc20: tttErc20Abi
}

export default abis
